$(document).ready(function(){

	if($(".dwnl-arrow").length > 0){
		var isAvastOne = avastDownloadLink.search(/avast-one/i);
		
		if ( $(document).width() > 1350 ){
				//$("body").append('<div class="dwnl-arrow-overlay"></div>');

				//show overlay only if the download file is not Avast One related!
				if (isAvastOne == -1){
					$( "<div></div>" )
						.addClass("dwnl-arrow-overlay")
						.wrapInner("<div class='close-dwnl-arrow-overlay'>x</div>")
						.on({click: function(event) {$(this).remove();}})
						.appendTo("body")
					;
				}

				//$(".dwnl-arrow-overlay").height( $("html").height() );
				//$(".dwnl-arrow-overlay").width( $("html").width() );
				$(".dwnl-arrow").addClass("dwnl-arrow-active").show();
		}

		var KEYCODE_ESC = 27;
		$(document).keyup(function(e) {
			if (e.keyCode == KEYCODE_ESC) { $('.dwnl-arrow-overlay').remove(); }
		});


		$(window).resize(function() {
			if ( $(document).width() < 1350 ){
				$(".dwnl-arrow").hide();
			}
			if ( $(document).width() > 1350 ){
				if ( $(".dwnl-arrow").hasClass("dwnl-arrow-active") ){
					$(".dwnl-arrow").show();
				}
			}
		});
	}


	if($( ".chrome-popup" ).length > 0){
		$( "body" ).append( '<div class="chrome-popup-overlay"></div>' );
		$( ".chrome-popup-overlay" ).append( $( ".chrome-popup" ) );
		//$( ".chrome-popup-overlay" ).height( $( "html" ).height( ) );

		$( ".chrome-popup-overlay" ).on( "click", function() {
			//$( this ).attr("class","chrome-popup-overlay2") ;
			//$( this ).css("background-color","transparent") ;
			$( this ).remove();
		});
	}
});